"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueueManagerService = void 0;
//ANGULAR 2 BITS
const core_1 = require("@angular/core");
const token_service_1 = require("./token.service");
let QueueManagerService = class QueueManagerService {
    constructor(_http) {
        this._http = _http;
        this.queueJsonBaseUrl = '/queue';
    }
    getStats() {
        return this._http.get(`${this.queueJsonBaseUrl}/stats`)
            .toPromise()
            .then(response => {
            return response.json() || null;
        });
    }
    getJobs(state, end, type) {
        //type = type || 'lineitemautomation';
        end = end || 10;
        return this._http.get(`${this.queueJsonBaseUrl}/jobs/${state}/0..${end}/desc `)
            .toPromise()
            .then(response => {
            return response.json() || null;
        });
    }
    deleteJob(jobId) {
        return this._http.delete(`${this.queueJsonBaseUrl}/job/${jobId}`)
            .toPromise()
            .then(response => {
            return response.json() || null;
        });
    }
};
exports.QueueManagerService = QueueManagerService;
exports.QueueManagerService = QueueManagerService = __decorate([
    (0, core_1.Injectable)(),
    __metadata("design:paramtypes", [token_service_1.TokenService])
], QueueManagerService);
//# sourceMappingURL=queue-manager.service.js.map